export const INTERNAL_SERVER_ERROR = 500;
export const BAD_REQUEST = 400;
export const GATEWAY_TIMEOUT = 504;
export const OK = 200;
export const FORBIDDEN = 403;
